import { Link } from "react-router-dom";
import { SITE, createWhatsAppLink } from "../config/site";
import { InstagramIcon, TikTokIcon } from "./SocialIcons";

export default function Footer() {
  return (
    <footer className="mt-16 border-t border-orange-100 bg-white">
      <div className="mx-auto grid max-w-7xl gap-10 px-4 py-12 sm:px-6 lg:grid-cols-[1.4fr_1fr_1fr_1.2fr] lg:px-8">
        <div>
          <div className="flex items-center gap-3">
            <div className="flex h-14 w-14 items-center justify-center rounded-full border border-slate-900 bg-[#171717] shadow-lg">
              <img src="/icon.png" alt="Petrah Collection logo" className="h-10 w-10 object-contain" />
            </div>
            <div>
              <div className="text-lg font-black tracking-tight text-slate-950">{SITE.displayName}</div>
              <p className="text-sm text-slate-500">{SITE.tagline}</p>
            </div>
          </div>

          <p className="mt-4 max-w-md text-sm leading-6 text-slate-600">{SITE.deliveryNote}</p>

          <div className="mt-5 flex flex-wrap gap-2">
            <a
              href={createWhatsAppLink()}
              target="_blank"
              rel="noreferrer"
              className="rounded-full bg-[#e46a2e] px-4 py-2 text-sm font-semibold text-white"
            >
              Order on WhatsApp
            </a>
            <a
              href={SITE.phoneHref}
              className="rounded-full border border-slate-200 px-4 py-2 text-sm font-semibold text-slate-700"
            >
              Call shop
            </a>
          </div>
        </div>

        <div>
          <h4 className="text-sm font-semibold uppercase tracking-[0.2em] text-slate-500">Shop</h4>
          <ul className="mt-4 space-y-3 text-sm text-slate-600">
            <li><Link to="/sneakers" className="hover:text-[#e46a2e]">Sneakers</Link></li>
            <li><Link to="/sport-shoes" className="hover:text-[#e46a2e]">Sports</Link></li>
            <li><Link to="/boots" className="hover:text-[#e46a2e]">Boots</Link></li>
            <li><Link to="/official-shoes" className="hover:text-[#e46a2e]">Official Shoes</Link></li>
            <li><Link to="/brands" className="hover:text-[#e46a2e]">Brands</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-sm font-semibold uppercase tracking-[0.2em] text-slate-500">Support</h4>
          <ul className="mt-4 space-y-3 text-sm text-slate-600">
            <li><Link to="/contact-us" className="hover:text-[#e46a2e]">Contact us</Link></li>
            <li><Link to="/faqs" className="hover:text-[#e46a2e]">FAQs</Link></li>
            <li><Link to="/shipping-policy" className="hover:text-[#e46a2e]">Shipping policy</Link></li>
            <li><Link to="/terms" className="hover:text-[#e46a2e]">Terms</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-sm font-semibold uppercase tracking-[0.2em] text-slate-500">Visit & Contact</h4>
          <ul className="mt-4 space-y-3 text-sm text-slate-600">
            <li>
              <span className="block font-semibold text-slate-900">{SITE.locationTitle}</span>
              <span>{SITE.locationLine}</span>
            </li>
            <li>
              <a href={SITE.phoneHref} className="hover:text-[#e46a2e]">{SITE.phoneDisplay}</a>
            </li>
            <li>
              <a href={`mailto:${SITE.email}`} className="break-all hover:text-[#e46a2e]">{SITE.email}</a>
            </li>
            <li className="whitespace-pre-line">{SITE.businessHoursDetailed}</li>
            <li className="flex flex-wrap gap-3 pt-2">
              <a
                href={SITE.instagram}
                target="_blank"
                rel="noreferrer"
                aria-label="Instagram"
                className="flex h-12 w-12 items-center justify-center rounded-2xl bg-[linear-gradient(135deg,#fd5949,#d6249f,#285AEB)] text-white shadow-sm transition hover:scale-[1.03]"
              >
                <InstagramIcon className="h-6 w-6" />
              </a>
              <a
                href={SITE.tiktok}
                target="_blank"
                rel="noreferrer"
                aria-label="TikTok"
                className="flex h-12 w-12 items-center justify-center rounded-2xl bg-slate-950 text-white shadow-sm transition hover:scale-[1.03]"
              >
                <TikTokIcon className="h-6 w-6" />
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-slate-200 py-4 text-center text-xs text-slate-500">
        © {new Date().getFullYear()} {SITE.legalName}. All rights reserved.
      </div>
    </footer>
  );
}
